module.exports = __webpack_public_path__ + "img/MTABAPPPHOTO.c2fd19aa.jpg";